import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-marketing-faq',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (items.length) {
      <div class="cg-mkt-faq">
        @for (f of items; track f.question) {
          <details>
            <summary>{{ f.question }}</summary>
            <p>{{ f.answer }}</p>
          </details>
        }
      </div>
    }
  `,
})
export class MarketingFaqComponent {
  @Input() items: Array<{ question: string; answer: string }> = [];
}
